import React from 'react';
import { StatusStyle } from '../Status/StatusDot';
import { constantToLabel } from '@ecosconnect/core/src/helpers/string';
import { InstallationStatusValue } from '@ecosconnect/core/src/types/jobFormData';

export const assemblyCompliantReasonStyle = (
  compliantReason:
    | 'FAILING'
    | 'PAST_DUE'
    | 'INSTALLATION'
    | 'PASSING'
    | 'PENDING'
): StatusStyle => {
  switch (compliantReason) {
    case 'INSTALLATION':
    case 'FAILING':
    case 'PAST_DUE':
      return 'error';
    case 'PASSING':
      return 'success';
    default:
      return 'primary';
  }
};

export const assemblyCompliantStyle = (compliant: boolean): StatusStyle => {
  switch (compliant) {
    case true:
      return 'success';
    case false:
      return 'error';
    default:
      return 'default';
  }
};

export const assemblyTestStatusStyle = (testStatus?: string): StatusStyle => {
  switch (testStatus) {
    case 'APPROVED':
      return 'success';
    case 'COMPLETED':
      return 'pending';
    case 'NOT_SCHEDULED':
      return 'error';
    case 'SCHEDULED':
      return 'primary';
    default:
      return 'default';
  }
};

export const assemblyTestStatusFormat = (testStatus?: string): string =>
  constantToLabel(testStatus);

export const installationStatusLabel = (status: InstallationStatusValue) => {
  switch (status) {
    case 1:
      return 'New';
    case 2:
      return 'Existing';
    case 3:
      return 'Removed';
    case 4:
      return 'Replacement';
  }
};
